import React, { ForwardedRef, forwardRef, useState } from 'react'
import { StyledVideo } from './VideoElement.style'

export interface IVideoElement {
  mediaSrc: string
  onLoadedMetadata: (event: React.SyntheticEvent<HTMLVideoElement, Event>) => void
  onTimeUpdate: (event: React.SyntheticEvent<HTMLVideoElement, Event>) => void
  handleMediaClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}

const VideoElement = (
  { mediaSrc, onLoadedMetadata, onTimeUpdate, handleMediaClick }: IVideoElement,
  ref: ForwardedRef<HTMLVideoElement | HTMLImageElement>,
) => {
  const [isFullscreen, setIsFullscreen] = useState(false)

  function toggleFullscreen() {
    // Type guard to check if ref is an object ref - for typescript
    if (ref && 'current' in ref && ref.current) {
      if (!document.fullscreenElement) {
        ref.current?.requestFullscreen()
      } else {
        document.exitFullscreen()
      }
      setIsFullscreen(!isFullscreen)
    }
  }

  return (
    <StyledVideo
      ref={ref}
      autoPlay
      muted
      onLoadedMetadata={onLoadedMetadata}
      onTimeUpdate={onTimeUpdate}
      onClick={handleMediaClick}
      onDoubleClick={toggleFullscreen}
      data-type="video-element"
    >
      <source src={mediaSrc} type="video/mp4" />
      Your browser does not support the video element.
    </StyledVideo>
  )
}

export default forwardRef(VideoElement)
